import { render, staticRenderFns } from "./MvMsgCount.vue?vue&type=template&id=97c962de&"
import script from "./MvMsgCount.vue?vue&type=script&lang=js&"
export * from "./MvMsgCount.vue?vue&type=script&lang=js&"
import style0 from "./MvMsgCount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports